import { request } from '@/lib/request'
import { ApiListResponse } from '@/types/common'

export interface Order {
    id: number;
    order_id: string;
    amount: number;
    status: string;
    pay_channel?: number;
    created_at: string;
    updated_at: string;
}

export async function getOrders(current: number = 1, page_size: number = 20) {
    return request<ApiListResponse<Order>>(`/api/orders/list?current=${current}&page_size=${page_size}`)
}

export async function createOrder(amount: number) {
    return request<Order>('/api/orders/create', {
        method: 'POST',
        body: JSON.stringify({ amount })
    })
}

export async function getOrderStatus(orderId: number | string) {
    return request<{ status: string }>(`/api/orders/status?order_id=${orderId}`)
}
